<template>
  <div class="account" ref="banner">
    <headerTop :mine='true' ref="title"></headerTop>
    <div class="title" ref="title" v-show="false">{{$t('my.myAccount')}}</div>
    <div ref="wrapper" class="main">
      <div style="padding-bottom:40px;" ref="wrapperItem">
        <div class="mycenter">
          <div class="myname">{{$t('my.myname')}}</div>
          <div class="head_img" >
            <img :src="avatar1?avatar1:defaultPhoto">
          </div>
          <div class="myedit" @click="personinfo"><img src="../../../static/img/login2/myedit.png" alt=""></div>
        </div>
        <!-- <div class="main-headportrait">
          <div class="user">
            <span class="nickname">{{message.nickname}}</span>
          </div>
        </div> -->
        <div class="mypet">
          <div class="tmypet"><span>{{$t('my.myPet')}}</span></div>
          <swiper :options="swiperOption">
            <swiper-slide v-for="(item,index) in petlist" :key="index">
              <img :src="item.portrait" />
              <p>{{item.name}}</p>
            </swiper-slide>
          </swiper>
          <div class="addpet">
            <ul>
              <li @click="addpet">
                <img :src="img1">
              </li>
            </ul>
          </div>
        </div>
        <div class="line"></div>
        <div class="six_part">
          <ul>
            <li @click="mysearch">
              <div class="partIcon"><img src="../../../static/img/account2/finder.png" alt=""></div>
              <div class="partCon">{{$t('my.myFinder')}}</div>
              <div class="partTo"><img src="../../../static/img/account2/left.png" alt=""></div>
            </li>
            <li @click="changepassword">
              <div class="partIcon"><img src="../../../static/img/account2/psw.png" alt=""></div>
              <div class="partCon">{{$t('my.changePsd')}}</div>
              <div class="partTo"><img src="../../../static/img/account2/left.png" alt=""></div>
            </li>
            <li>
              <a  v-if="lang=='zh'?true:false"
                :href="'http://apicn.dognessnetwork.com:8666/requestCustomerService?username='+message.username+'&token='+authtoken+'&platForm=web&area='+lang"
              >
                <div class="partIcon"><img src="../../../static/img/account2/service.png" alt=""></div>
                <div class="partCon">{{$t('my.onlineService')}}</div>
                <div class="partTo"><img src="../../../static/img/account2/left.png" alt=""></div>
              </a>
              <a v-if="lang=='en'?true:false"
                :href="'http://apius.dognessnetwork.com:8666/requestCustomerService?username='+message.username+'&token='+authtoken+'&platForm=web&area='+lang"
              >
                <div class="partIcon"><img src="../../../static/img/account2/service.png" alt=""></div>
                <div class="partCon">{{$t('my.onlineService')}}</div>
                <div class="partTo"><img src="../../../static/img/account2/left.png" alt=""></div>
              </a>
            </li>
            <li @click="toFAQ">
              <div class="partIcon"><img src="../../../static/img/account2/questions.png" alt=""></div>
              <div class="partCon">{{$t('my.FAQ')}}</div>
              <div class="partTo"><img src="../../../static/img/account2/left.png" alt=""></div>
            </li>
            <li @click="out">
              <div class="partIcon"><img src="../../../static/img/account2/out.png" alt=""></div>
              <div class="partCon">{{$t('my.exit')}}</div>
              <div class="partTo"><img src="../../../static/img/account2/left.png" alt=""></div>
            </li>
          </ul>
        </div>
        <!-- <div class="main-before">
          <ul>
            <li>
              <img src="../../image/personmsg.png" @click="personinfo">
              <p>{{$t('my.masterInfo')}}</p>
            </li>
            <li @click="mysearch">
              <img src="../../image/myfind.png">
              <p>{{$t('my.myFinder')}}</p>
            </li>
            <li @click="changepassword">
              <img src="../../image/changepassword .png">
              <p>{{$t('my.changePsd')}}</p>
            </li>
          </ul>
        </div>
        <div class="main-after">
          <ul>
            <li>
              <a  v-if="lang=='zh'?true:false"
                :href="'http://apicn.dognessnetwork.com:8666/requestCustomerService?username='+message.username+'&token='+authtoken+'&platForm=web&area='+lang"
              >
                <img src="../../image/Customer.png">
                <p>{{$t('my.onlineService')}}</p>
              </a>
              <a v-if="lang=='en'?true:false"
                :href="'http://apius.dognessnetwork.com:8666/requestCustomerService?username='+message.username+'&token='+authtoken+'&platForm=web&area='+lang"
              >
                <img src="../../image/Customer.png">
                <p>{{$t('my.onlineService')}}</p>
              </a>
            </li>
            <li>
              <a @click="toFAQ">
                <img src="../../image/question.png">
                <p>{{$t('my.FAQ')}}</p>
              </a>
            </li>
            <li @click="out">
              <img src="../../image/out.png">
              <p>{{$t('my.exit')}}</p>
            </li>
          </ul>
        </div> -->
      </div>
    </div>
    <v-foot :loginsuccess="loginsuccess" :loginshowflag="loginshowflag"></v-foot>
  </div>
</template>
<script>
import IScroll from "iscroll/build/iscroll-probe";
import footernav from "../../components/footernav";
import 'swiper/dist/css/swiper.css'
import { getpet } from "../../ClientServerApi/index.js";
import headerTop from "../../components/header";
import { updateUserInfo, getLoginUser } from "../../api/index.js";
import axios from "axios";
import Qs from "qs";
let vm=null;
export default {
  name: "account",
  data() {
    return {
      message: {
        nickname: "",
        username: "",
        mobile: ""
      },
      defaultPhoto: require("../../image/addmypet.png"),
      listshow: false,
      loginsuccess: false,
      loginshowflag: true,
      flag: true,
      user: "",
      avatar1: "",
      imgflag: false,
      authtoken: sessionStorage.token,
      img1: require("../../image/addmypet.png"),
      petlist: "",
      swiperOption: {
        autoplay: false,
        // autoplayDisableOnInteraction: false,//操作swiper之后，仍保持自动轮播
        setWrapperSize: true,
        loop: false,
        pagination: '.swiper-pagination',
        paginationClickable: true,
        mousewheelControl: false,
        observeParents: true,
        slidesPerView : 3,
        slidesPerGroup : 3,
        on:{
          click:function(){
            const realIndex = this.clickedIndex;//this 指向的是 swpier 实例，而不是当前的 vue
            vm.petinfo(realIndex);//借助 vm，来调用 methods 里的方法
          }
        }
      },
      index: "",
      lang: localStorage.getItem("locale")
    };
  },
  created() {
    vm = this;
    if (sessionStorage.getItem("login")) {
      this.loginsuccess = true;
      this.loginshowflag = false;
    }
    //检验是否登录超时
    if (sessionStorage.getItem("login") == 1) {
      getLoginUser()
        .then(res => {
          // console.log("检测是否登录：",res)
          if (res.data.header.status == 3038) {
            sessionStorage.setItem("login", "1");
            this.$message({
              type: "success",
              message: this.$t("prompt.header")
            });
            this.$router.push("/login");
          }
        })
        .catch(err => {});
    }
    var geolocation = new BMap.Geolocation();
    geolocation.getCurrentPosition(
      function(r) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
          // console.log(r.point);
          sessionStorage.setItem("lng", r.point.lng);
          sessionStorage.setItem("lat", r.point.lat);
        } else {
          alert("failed" + this.getStatus());
        }
      },
      {
        enableHighAccuracy: true
      }
    );
    this.$nextTick(() => {
      this.Scroll = new IScroll(this.$refs.wrapper, {
        click: true
      });
    });
    // console.log("account-token", sessionStorage.token);
  },
  mounted() {
    console.log(this.lang)
    this.$refs.wrapper.style.top = this.$refs.title.offsetHeight + 40 + "px";
    this.$refs.wrapper.style.height = document.documentElement.clientHeight-40+'px';
    console.log(this.$refs.wrapper.style.height)
    this.$refs.wrapperItem.style.height="auto"
    getLoginUser()
      .then(res => {
        console.log(res)
        // if (res.data.data.email == null || res.data.data.mobile == null) {
        //   this.$router.push("/mynewsedit");
        // }
        this.message.nickname = res.data.data.nickname;
        this.message.username = res.data.data.username;
        this.message.mobile = res.data.data.mobile;
        this.avatar1 = res.data.data.photoUrl;
        // console.log(this.message.username);
      })
      .catch(error => {
        console.log(error);
      });
    getpet()
      .then(res => {
        // console.log(res)
        if (res.data.header.status == 1000) {
          this.petlist = res.data.data;
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  methods: {
    personinfo() {
      this.$router.push({ path: "/mynews" });
    },
    petinfo(index) {
      // console.log("5555:",index)
      let ger = "";
      if (this.petlist[index].gender == "男孩") {
        ger = this.$t("prompt.boy");
      } else {
        ger = this.$t("prompt.girl");
      }
      this.$router.push({
        path: "/petinfo",
        query: {
          petname: this.petlist[index].name,
          pettype: this.petlist[index].petType,
          haircolor: this.petlist[index].color,
          // sex: this.petlist[index].gender,
          sex: ger,
          weight: this.petlist[index].weight,
          height: this.petlist[index].height,
          birthTime: this.petlist[index].birthTime,
          character: this.petlist[index].character,
          src: this.petlist[index].portrait,
          id: this.petlist[index].id
        }
      });
    },
    addpet() {
      this.$router.push({ path: "/addpet" });
    },
    mysearch() {
      this.$router.push({ path: "/mysearch" });
    },
    changepassword() {
      this.$router.push({ path: "/changepassword" });
    },
    out() {
      this.$confirm(this.$t("my.isExit"), {
        confirmButtonText: this.$t("addDevice.sure"),
        cancelButtonText:  this.$t("addDevice.cancel"),
        type: "warning"
      })
        .then(() => {
          this.$router.push({ path: "/login" });
          sessionStorage.removeItem("login");
          localStorage.removeItem("token")
        })
        .catch(() => {});
    },
    inputName() {
      if (this.user.replace(/[\u4E00-\u6FA5]/g, "****").length > 32) {
        // console.log(this.user.replace(/[\u4E00-\u6FA5]/g, "****").length);
        this.user = this.user.substring(0, 32);
      }
    },
    toFAQ(){
        this.$router.push('/FAQ')
    }
  },
  components: {
    "v-foot": footernav,
    headerTop
  }
};
</script>
<style>
.account .el-message-box {
  width: 80%;
  margin: inherit;
  float: left;
}
.account .swiper-container{
  width: 75%;
  margin: inherit;
  float: left;
  text-align: center;
}
</style>
<style scoped>
.account{
  position: relative;
  background: #f6f6f6;
}
.nickname {
  display: block;
  z-index: 100;
}
.title {
  text-align: center;
  font-size: 0.8rem;
  width: 100%;
  padding: 5px 0;
  color: #828282;
  background-color: #fff;
}

.main-header span {
  letter-spacing: 1px;
}
.mycenter{
  width: 100%;
  height: 12rem;
  background-image: url(../../../static/img/login2/mycenterbg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display:inline-flex;
  justify-content: space-between;
  padding-top: 1rem;
}
.myname{
  font-weight: bold;
}
.myname,.myedit{
  width: 30%;
  padding: 0.5rem;
}
.myedit{
  text-align: right;
}
.myedit img{
  width: 1.2rem;
}
.head_img img {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  margin-top: 2rem;
}

.hiddenInput {
  display: none;
}
.main-headportrait p {
  text-align: center;
  padding: 5px 0px;
  color: rgb(63, 63, 63);
  font-family: "微软雅黑";
  font-size: 0.9rem;
}
.user {
  line-height: 30px;
  height: 30px;
  text-align: center;
  position: relative;
  border-bottom: solid 1px #dcdcdc;
}
.user span {
  font-size: 0.9rem;
}

.mypet{
  position: absolute;
  box-sizing: border-box;
  top: 8.5rem;
  padding: 0.5rem;
  width: 92%;
  left: 4%;
  background: #ffffff;
  border-radius: 0.5rem;
}
.tmypet{
  width: 100%;
  margin-bottom: 10px;
}
.tmypet span {
  font-size: 0.9rem;
  font-weight: bold;
  border-bottom: 2px solid #7dc3f2;
}

.mypet img{
  width: 2.8rem;
  height: 2.8rem;
  border-radius: 50%;
  object-fit:cover ;
}

.addpet{
  width: 25%;
  float: left;
  text-align: center;
}
.mypet p {
  font-size: 0.75rem;
  color: #333333;
  margin-top: 5px;
  margin-bottom: 5px;
  text-align: center;
}

.line {
  clear: both;
  width: 100%;
  height: 0px;
  margin-top: 3.5rem;
}

.six_part{
  width: 92%;
  margin: 0 auto;
  background: #fff;
  border-radius: 0.5rem;
  padding: 1rem;
  box-sizing: border-box;
  margin-bottom: 2rem;
}
.six_part ul li{
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
  font-size: 0.9rem;
  height: 2.5rem;
  line-height: 2.5rem;
  color: #252525;
}
.six_part a {
  display: block;
  width: 100%;
  font-size: 0.9rem;
  height: 2.5rem;
  line-height: 2.5rem;
  color: #252525;
}
.partCon{
  width: 80%;
  float: left;
}
.partIcon,.partTo{
  width: 10%;
  float: left;
  height: 2.5rem;
  line-height: 2.5rem;
}
.partIcon img{
  width: 1.3rem;
  vertical-align: middle;
}
.partTo{
  text-align: right;
}
.partTo img{
  width: 0.5rem;
  vertical-align: middle;
}



/* .main-before ul {
  display: flex;
}
.main-before ul li {
  flex: 1;
  border-right: solid 1px rgb(222, 222, 222);
  border-bottom: solid 1px rgb(222, 222, 222);
}
.main-before ul li:nth-child(3) {
  border-right: none;
}
.main-before ul li img {
  width: 3.125rem;
  height: 3.125rem;
  margin: 10px auto;
  display: block;
}
.main-before ul li p {
  color: rgb(63, 63, 63);
  text-align: center;
  font-size: 0.8rem;
  margin-bottom: 10px;
}
.main-after ul {
  display: flex;
}
.main-after ul li {
  flex: 1;
  border-right: solid 1px rgb(222, 222, 222);
  border-bottom: solid 1px rgb(222, 222, 222);
}
.main-after ul li:nth-child(3) {
  border-right: none;
}
.main-after ul li:nth-child(2) img {
  width: 30px;
}
.main-after ul li img {
  width: 3.125rem;
  height: 3.125rem;
  margin: 10px auto;
  display: block;
}
.main-after ul li p {
  color: rgb(63, 63, 63);
  text-align: center;
  font-size: 0.8rem;
  margin-bottom: 10px;
} */
.main {
  overflow: hidden;
  position: absolute;
  bottom: 40px;
  top: 55px;
  width: 100%;
  max-width: 579px;
  touch-action: none;
  background: #f6f6f6;
}
</style>




// WEBPACK FOOTER //
// src/m_page/myAccount/account.vue